import React, { createRef, useMemo, useState } from "react";
import Headerback from "../../../component/headerback";
import Question from "../../pretest/question";

let gapPro = [
    { idPro: 1, upper: '艰难苦恨繁霜鬓，', next: '潦倒新停浊酒杯。', title: '（《登高》杜甫）', show: 1 },
    { idPro: 2, upper: '风急天高猿啸哀，', next: '渚清沙白鸟飞回。', title: '（《登高》杜甫）', show: -1 },
    { idPro: 3, upper: '无边落木萧萧下，', next: '不尽长江滚滚来。', title: '（《登高》杜甫）', show: 1 },
    { idPro: 4, upper: '落木千山天远大，', next: '澄江一道月分明。', title: '（《登快阁》黄庭坚）', show: -1 },
    { idPro: 5, upper: '朱弦已为佳人绝，', next: '青眼聊因美酒横。', title: '（《登快阁》黄庭坚）', show: -1 },
    { idPro: 6, upper: '万里归船弄长笛，', next: '此心吾与白鸥盟。', title: '（《登快阁》黄庭坚）', show: -1 },
];

const defalutschema = {
    id: 1,
    desc: '检测四',
    totalScore: 0,
    question: [
        {
            id: 2,
            desc: '关于“风急天高猿啸哀，渚清沙白鸟飞回。无边落木萧萧下，不尽长江滚滚来。万里悲秋常作客，百年多病独登台。艰难苦恨繁霜鬓，潦倒新停浊酒杯。”这首诗（《登高》杜甫），理解错误的一项是()',
            the_score: 0,
            options: [
                {
                    label: '首联用“风急”二字带动全联，其中风、渚，天、沙，猿啸、鸟飞，对仗工整。',
                    value: '首联用“风急”二字带动全联，其中风、渚，天、沙，猿啸、鸟飞，对仗工整。',
                    score: 1,
                    selected: false,
                },
                {
                    label: '颔联“萧萧”“滚滚” 使“无边落木”“不尽长江”更加形象，景象萧瑟、阔远。',
                    value: '颔联“萧萧”“滚滚” 使“无边落木”“不尽长江”更加形象，景象萧瑟、阔远。',
                    score: 0,
                    selected: false,
                },
                {
                    label: '“悲秋”二字是诗眼，前四句抒发登台所感的悲情，后四句描写登台所见的秋景。',
                    value: '“悲秋”二字是诗眼，前四句抒发登台所感的悲情，后四句描写登台所见的秋景。',
                    score: 0,
                    selected: false,
                },
            ],
            selected: [],
        },
    ],
};

window.localStorage.schema = JSON.stringify(defalutschema);

let a_schema;
try {
    a_schema = JSON.parse(window.localStorage.schema);
} catch { }

export default function Classfour() {
    const filteredPool = [0, 1, 2];   // 固定题目索引

    const [schema] = useState(a_schema);
    let { question, desc } = schema;
    const [finish, setFinish] = useState(false);
    const [finishScore, setFinishScore] = useState(0);
    const [btnDisabled, setBtnDisabled] = useState(false);
    const [show, setShow] = useState([-1, -1, -1]);
    const [inputValue1, setInputValue1] = useState('');
    const [inputValue2, setInputValue2] = useState('');
    const [inputValue3, setInputValue3] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    let totalScore;
    let newSchema = { id: 1, totalScore: 0, question: [] };

    const refs = useMemo(() => question.map(() => createRef()), [question]);

    const handleSave = () => {
        if (isSubmitting) return;
        setIsSubmitting(true);
        setBtnDisabled(true);

        setFinish(true);
        totalScore = 0;
        schema.question.forEach((item, index) => {
            const { getSchema } = refs[index].current;
            newSchema.question.push(getSchema());
            if (getSchema().the_score) {
                totalScore += getSchema().the_score;
            }
        });

        let trueAnswer = [];
        filteredPool.forEach((item, index) => {
            if (index === 0) {
                if (gapPro[item].show === -1) {
                    trueAnswer.push(gapPro[item].next.replace(/。/g, ""));
                    if (inputValue1 === gapPro[item].next.replace(/。/g, "")) {
                        totalScore += 1;
                        const newShow = [...show];
                        newShow[index] = 1;
                        setShow(newShow);
                    } else {
                        const newShow = [...show];
                        newShow[index] = 0;
                        setShow(newShow);
                    }
                } else if (gapPro[item].show === 1) {
                    trueAnswer.push(gapPro[item].upper.replace(/，/g, ""));
                    if (inputValue1 === gapPro[item].upper.replace(/，/g, "")) {
                        totalScore += 1;
                        const newShow = [...show];
                        newShow[index] = 1;
                        setShow(newShow);
                    } else {
                        const newShow = [...show];
                        newShow[index] = 0;
                        setShow(newShow);
                    }
                }
            } else if (index === 1) {
                if (gapPro[item].show === -1) {
                    trueAnswer.push(gapPro[item].next.replace(/。/g, ""));
                    if (inputValue2 === gapPro[item].next.replace(/。/g, "")) {
                        totalScore += 1;
                        const newShow = [...show];
                        newShow[index] = 1;
                        setShow(newShow);
                    } else {
                        const newShow = [...show];
                        newShow[index] = 0;
                        setShow(newShow);
                    }
                } else if (gapPro[item].show === 1) {
                    trueAnswer.push(gapPro[item].upper.replace(/，/g, ""));
                    if (inputValue2 === gapPro[item].upper.replace(/，/g, "")) {
                        totalScore += 1;
                        const newShow = [...show];
                        newShow[index] = 1;
                        setShow(newShow);
                    } else {
                        const newShow = [...show];
                        newShow[index] = 0;
                        setShow(newShow);
                    }
                }
            } else if (index === 2) {
                if (gapPro[item].show === -1) {
                    trueAnswer.push(gapPro[item].next.replace(/。/g, ""));
                    if (inputValue3 === gapPro[item].next.replace(/。/g, "")) {
                        totalScore += 1;
                        const newShow = [...show];
                        newShow[index] = 1;
                        setShow(newShow);
                    } else {
                        const newShow = [...show];
                        newShow[index] = 0;
                        setShow(newShow);
                    }
                } else if (gapPro[item].show === 1) {
                    trueAnswer.push(gapPro[item].upper.replace(/，/g, ""));
                    if (inputValue3 === gapPro[item].upper.replace(/，/g, "")) {
                        totalScore += 1;
                        const newShow = [...show];
                        newShow[index] = 1;
                        setShow(newShow);
                    } else {
                        const newShow = [...show];
                        newShow[index] = 0;
                        setShow(newShow);
                    }
                }
            }
        });

        newSchema.totalScore = totalScore;
        window.localStorage.schema = JSON.stringify(newSchema);
        setFinishScore(newSchema.totalScore);
        alert(`你本次答对${newSchema.totalScore}道题!\n 1、答案： \n（1）${trueAnswer[0]}\n（2）${trueAnswer[1]}\n（3）${trueAnswer[2]} \n 2、解析：前两句从远景入手，所以A项中“近景”是错误的。`);
    };

    let flag = 0;
    const getPro = (item) => {
        flag++;
        if (item.show === -1) {
            if (flag === 1) {
                return (
                    <div className="wrapper">
                        ({flag})&nbsp;&nbsp;{item.upper}
                        <input type="text" className="question-input" onChange={changeInput1} />。
                        {getTag(flag - 1, show)}
                        <br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;——{item.title}
                    </div>
                );
            } else if (flag === 2) {
                return (
                    <div className="wrapper">
                        ({flag})&nbsp;&nbsp;{item.upper}
                        <input type="text" className="question-input" onChange={changeInput2} />。
                        {getTag(flag - 1, show)}
                        <br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;——{item.title}
                    </div>
                );
            } else if (flag === 3) {
                return (
                    <div className="wrapper">
                        ({flag})&nbsp;&nbsp;{item.upper}
                        <input type="text" className="question-input" onChange={changeInput3} />。
                        {getTag(flag - 1, show)}
                        <br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;——{item.title}
                    </div>
                );
            }
        } else if (item.show === 1) {
            if (flag === 1) {
                return (
                    <div className="wrapper">
                        ({flag})&nbsp;&nbsp;
                        <input type="text" className="question-input" onChange={changeInput1} />，{item.next}
                        {getTag(flag - 1, show)}
                        <br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;——{item.title}
                    </div>
                );
            } else if (flag === 2) {
                return (
                    <div className="wrapper">
                        ({flag})&nbsp;&nbsp;
                        <input type="text" className="question-input" onChange={changeInput2} />，{item.next}
                        {getTag(flag - 1, show)}
                        <br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;——{item.title}
                    </div>
                );
            } else if (flag === 3) {
                return (
                    <div className="wrapper">
                        ({flag})&nbsp;&nbsp;
                        <input type="text" className="question-input" onChange={changeInput3} />，{item.next}
                        {getTag(flag - 1, show)}
                        <br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;——{item.title}
                    </div>
                );
            }
        }
        return null;
    };

    const changeInput1 = (e) => setInputValue1(e.target.value);
    const changeInput2 = (e) => setInputValue2(e.target.value);
    const changeInput3 = (e) => setInputValue3(e.target.value);

    const getTag = (index, show) => {
        if (show[index] === 0) {
            return <div className="cuoicon iconfont icon-cuo"></div>;
        } else if (show[index] === 1) {
            return <div className="duiicon iconfont icon-zhengque-correct"></div>;
        } else {
            return "";
        }
    };

    return (
        <div>
            <Headerback showPage={2} />
            <div className="page course-page">
                <div className="page-con">
                    <div className="problem">
                        <div className="problem-inner">
                            <p className="desc">{desc}</p>

                            <div className="question">
                                <p className="title1">1、补全诗句</p>
                                {filteredPool.map((item, index) => {
                                    return getPro(gapPro[item]);
                                })}
                            </div>

                            {schema.question.map((item, index) => (
                                <div key={item.id} className="question">
                                    <p className="title">{item.id}、{item.desc}</p>
                                    <Question finish={finish} item={item} ref={refs[index]} yanz={[1, 1, 2]} />
                                </div>
                            ))}
                        </div>
                    </div>
                    <button
                        className="miaov-btn miaov-btn-md problem-btn"
                        type="submit"
                        onClick={handleSave}
                        disabled={btnDisabled}
                        style={{
                            backgroundColor: btnDisabled ? 'gray' : '',
                            cursor: btnDisabled ? 'default' : 'pointer',
                            display: btnDisabled ? 'none' : 'inline-block',
                        }}
                    >
                        提交
                    </button>
                </div>
            </div>
        </div>
    );
}